import {
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_ALBUM,
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_ARTICLE,
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_SHARE,
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_SHORT_MESSAGE,
    ERROR_PLEASE_RELOAD,
} from 'mk/autogenerated/translations/deletePost.5b313010213fbe6759356829b77c2b0f'
import * as msgs from 'mk/msgs';
import { photoblog_api_v1_delete_post_url } from 'mk/urls/functions';
import * as xhr from 'mk/xhr/client';

const confirmations = {
    1: ARE_YOU_SURE_YOU_WANT_TO_DELETE_ALBUM,
    2: ARE_YOU_SURE_YOU_WANT_TO_DELETE_SHORT_MESSAGE,
    3: ARE_YOU_SURE_YOU_WANT_TO_DELETE_ARTICLE,
    4: ARE_YOU_SURE_YOU_WANT_TO_DELETE_SHORT_MESSAGE,
    5: ARE_YOU_SURE_YOU_WANT_TO_DELETE_SHARE,
};

export default function deletePost(username, postId, postType) {
    if (!postType) {
        // Defaults to short message
        postType = 2;
    }

    if (confirm(confirmations[postType])) {
        const url = photoblog_api_v1_delete_post_url(username, postId);
        xhr.post(url)
            .then(
                (response) => {
                    const post = document.getElementById(`post-${postId}`);
                    if (post) {
                        post.parentNode.removeChild(post);
                    }
                    msgs.alert(response.body.message);
                },
                () => msgs.error(ERROR_PLEASE_RELOAD),
            );
    }
}
